import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpacer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSpacer"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V5.5H2V4ZM2 4H22V5.5H2V4ZM2 4H22V5.5H2V4ZM2 4H22V5.5H2V4ZM2 4H22V5.5H2V4Z" fill="currentColor"/><Path d="M6 11.25V12.75H2V11.25H6Z" fill="currentColor"/><Path d="M14 11.25V12.75H10V11.25H14Z" fill="currentColor"/><Path d="M22 11.25V12.75H18V11.25H22Z" fill="currentColor"/><Path d="M22 18.5V20H2V18.5H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpacer;
